import { render, staticRenderFns } from "./RegisterLocation.vue?vue&type=template&id=6e739856&"
import script from "./RegisterLocation.vue?vue&type=script&lang=js&"
export * from "./RegisterLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports